import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../hooks";
import { getEmployees } from "../slices/employeeSlice";

export const useEmployees = () => {
    const dispatch = useAppDispatch();
    const { employees, loading, error, success } = useAppSelector((state) => state.employees);

    useEffect(() => {
        if (!employees || employees.length === 0) {
            console.log("Fetching exmployees...", loading);
            dispatch(getEmployees());
        }
    }, [dispatch]);

  return { employees, loading, error, success };
};